/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, DateRange, Highcharts, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var NOT_AN_IPAD = `NOT AN IPAD`;

  // http://theiphonewiki.com/wiki/Firmware#iPad_mini
  var ipad_model_name = function(model_id) {
    if (model_id.match(/^iPad1,.$/)) {
      return `iPad 1`;
    } else if (model_id.match(/^iPad2,[1234]$/)) {
      return `iPad 2`;
    } else if (model_id.match(/^iPad2,[567]$/)) {
      return `iPad Mini`;
    } else if (model_id.match(/^iPad3,[123]$/)) {
      return `iPad 3`;
    } else if (model_id.match(/^iPad3,[456]$/)) {
      return `iPad 4`;
    } else if (model_id.match(/^iPad4,[123]$/)) {
      return `iPad Air`;
    } else if (model_id.match(/^iPad4,[456]$/)) {
      return `iPad Mini 2`;
    } else if (model_id.match(/^iPad4,[789]$/)) {
      return `iPad Mini 3`;
    } else if (model_id.match(/^iPad5,[34]$/)) {
      return `iPad Air 2`;
    }
    return NOT_AN_IPAD;
  };


  ns.IPadModels = mp.marketing.trends.widgets.TrendReport.extend({
    get_defaults() {
      return {
        date_range: new DateRange(new Date(2013, 9, 31), new Date()),
      };
    },

    get_queries() {
      var unit = `week`;
      var date_range = this.session.get(`date_range`);
      if (date_range.days() <= 35) {
        unit = `day`;
      }
      return {
        base: {
          'query_name': `ios_device_models`,
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
          unit,
        },
      };
    },

    get_chart_params(query_data) {
      var date_format = `yyyy-MM-dd`;

      var models_to_series = _.groupBy(query_data.base, function(_, model_id) {
        return ipad_model_name(model_id);
      });
      delete models_to_series[NOT_AN_IPAD];

      var models_to_one_series = {};
      var totals = {};
      _.each(models_to_series, function(serieses, model_name) {
        var this_model = {};
        _.each(serieses, function(one_series) {
          _.each(one_series, function(count, date) {
            if (! this_model[date]) {
              this_model[date] = 0;
            }
            if (! totals[date]) {
              totals[date] = 0;
            }
            this_model[date] += count;
            totals[date] += count;
          });
        });
        models_to_one_series[model_name] = this_model;
      });

      var color_ix = -1;
      var chart_data = _.map(models_to_one_series, function(series, model) {
        color_ix++;
        return {
          name: model,
          color: mp.charts.nth_color(color_ix),
          data: _.map(series, function(val, date) {
            var unixtime = Date.parseExact(date, date_format).getTime();
            var percent = 0;
            if (totals[date]) {
              percent = (val / totals[date]) * 100;
            }
            return [unixtime, percent];
          }).sort(),
        };
      });

      return {
        'chart': {
          'marginBottom': 100,
        },
        'xAxis': {
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e`, this.value);
            },
          },
          'type': `datetime`,
        },
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': chart_data,
        'tooltip': {
          'shared': true,
          'crosshairs': true,
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'useHTML': false,
          'pointFormat': `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>`,
          'valueDecimals': 2,
        },
      };
    },

    getDownloadName() {
      return ns.IPadModels.nice_name;
    },
  });

  ns.IPadModels.slug = `ipad_models`;
  ns.IPadModels.nice_name = `iPad models`;
  ns.IPadModels.description = `How quickly will people start using the new iPad Air and Mini 2?`;
  ns.IPadModels.chart_type = `line`;
});

}.call(window));